export default __webpack_public_path__ + "static/media/TemNoParque.4690bb2a.svg";